import { call, select } from 'redux-saga/effects';
import { getInsuranceData as getInsuranceDataAda } from '@bitComponents/adabyron/catalog';

const contextStore = state => state.context.data;

export function* getInsuranceData(params) {
  const {
    idMemory,
    idSeguroPO,
    insuranceType,
    productOfferingId,
    reduxUpdate,
    normalizeHttpErrors,
  } = params;

  const args = {
    idMemory,
    idSeguroPO,
    insuranceType,
    productOfferingId,
  };

  try {
    const context = yield select(contextStore);
    const response = yield call(getInsuranceDataAda, args, context);
    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
